<div class="numero_piezas">{{ numeroPedidosRechazados }}</div>
<div class="descripcion rechazado">PEDIDOS RECHAZADOS</div>
